'use client';

import { ErrorStatusView } from 'ui-components/error/ErrorStatusView';
import { getStatusCodeFromError } from 'utils/httpError';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  const statusCode = getStatusCodeFromError(error);

  return <ErrorStatusView statusCode={statusCode} />;
}
